// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6635":"css/admin-app.7053","8955":"css/app.7053"}[chunkId] + ".css";
};